import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { useUpdateAdsPointsSettingMutation } from "../../redux/adsApi";
import { useTranslation } from "react-i18next";

function EditAdsPointsSetting({ show, onHide, editData }) {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({ 
        id: "", 
        ads_number: "", 
        ads_point: "", 
        status: "active" 
    });
    const [updateAdsPointsSetting, { isLoading }] = useUpdateAdsPointsSettingMutation();

    useEffect(() => {
        if (editData) {
            setFormData({
                id: editData.id || "",
                ads_number: editData.ads_number || "",
                ads_point: editData.ads_point || "",
                status: editData.status || "active",
            });
        }
    }, [editData]);

    const handleSave = async () => {
        if (!formData.ads_number || !formData.ads_point) {
            toast.error(t('fill_required_fields') || "All fields are required!");
            return;
        }

        const submitData = {
            id: formData.id,
            ads_number: formData.ads_number,
            ads_point: formData.ads_point,
            status: formData.status
        };

        try {
            const response = await updateAdsPointsSetting(submitData).unwrap();
            if (response.status) {
                toast.success(response.message || "Ads Points Setting updated successfully!");
                onHide();
            } else {
                toast.error(response.message || "Failed to update ads points setting");
            }
        } catch (error) {
            toast.error(error?.data?.message || "Error updating ads points setting");
            console.error("Error updating ads points setting:", error);
        }
    };

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>{t('edit_admob_points_setting') || 'Edit AdMob Points Setting'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label>{t('ads_number') || 'Ads Number'}</Form.Label>
                        <Form.Control
                            type="number"
                            value={formData.ads_number}
                            onChange={(e) => setFormData({ ...formData, ads_number: e.target.value })}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>{t('ads_point') || 'Ads Point'}</Form.Label>
                        <Form.Control
                            type="number"
                            value={formData.ads_point}
                            onChange={(e) => setFormData({ ...formData, ads_point: e.target.value })}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>{t('status') || 'Status'}</Form.Label>
                        <Form.Select
                            value={formData.status}
                            onChange={(e) => setFormData({ ...formData, status: e.target.value })}
                        >
                            <option value="active">{t('active') || 'Active'}</option>
                            <option value="inactive">{t('inactive') || 'Inactive'}</option>
                        </Form.Select>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    {t('close') || 'Close'}
                </Button>
                <Button variant="primary" onClick={handleSave} disabled={isLoading}>
                    {t('save') || 'Save'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default EditAdsPointsSetting;
